import React, {
  useState, useEffect
} from 'react';
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify';
import { Toast } from 'containers';
import { queryContestFilters } from 'services/requests';
import { Form } from 'components/atoms';
import { Formik, Field } from 'formik';
import { FieldSelect, FieldCustom } from 'components/molecules';
import * as Yup from 'yup';
import cleanDeep from 'clean-deep';
import queryString from 'query-string';

const ContestsSchema = Yup.object().shape({
  contestsTitle: Yup.string(),
  contestType: Yup.number(),
  states: Yup.array(Yup.number())
})

const computeOptions = (opts, valueKey = 'id', labelKey = 'name', tabLabelKey = 'text') => opts.map((option) => ({
  value: option[valueKey],
  label: option[labelKey] || option[tabLabelKey],
  original: option
}))

const ContestsEditor = ({ initialProps, onChange }) => {
  const [isLoading, setLoading] = useState(true);
  const [types, setTypes] = useState([]);
  const [states, setStates] = useState([]);
  const { lang } = useParams()

  const getContestOptionsData = async () => {
    try {
      const dirty = {
        language: lang
      };
      const params = cleanDeep(dirty);
      const query = queryString.stringify(params);
      setLoading(true)
      const response = await queryContestFilters(query);
      setTypes(computeOptions(response.data.types));
      const statesFiltered = response.data.states.filter(
        ({ id }) => !initialProps.statesToIgnore.includes(id)
      )
      setStates(computeOptions(statesFiltered));
      setLoading(false)
    } catch (err) {
      setLoading(false)
      toast.error(
        <Toast
          type="error"
          title="Erro a carregar formulário de Concursos"
          description={err.message}
        />
      );
      // eslint-disable-next-line no-console
      console.error(err);
    }
  }

  useEffect(() => {
    getContestOptionsData();
  }, []);

  const handleFormChange = (newValues) => {
    const selectedStates = states.filter((state) => newValues.states.includes(state.value));
    const tabs = selectedStates.map((state) => state.original);
    const newProps = {
      ...initialProps, ...newValues, tabs
    };
    onChange(newProps);
  }

  if (isLoading) {
    return (
      <div>
      A carregar...
      </div>
    )
  }

  return (
    <div>
      <Formik
        initialValues={{
          contestsTitle: initialProps.contestsTitle,
          contestType: initialProps.contestType,
          states: initialProps.states
        }}
        validationSchema={ContestsSchema}
        validate={handleFormChange}
      >
        <Form>
          <Field
            title="Título"
            name="contestsTitle"
            component={FieldCustom}
            maxLetters={120}
          />
          <Field
            title="Tipo de concurso"
            name="contestType"
            placeholder="Selecione um tipo de concurso..."
            component={FieldSelect}
            options={types}
          />
          <Field
            title="Fase de procedimento"
            name="states"
            options={states}
            component={FieldSelect}
            placeholder="Selecione fases de procedimento..."
            isMulti
          />
        </Form>
      </Formik>
    </div>
  );
};

export default ContestsEditor;
